import DocumentMeta from "react-document-meta";
const { useState } = require("react");

const openGmail = () => {
    const name = document.getElementById('name').value;
    const email = document.getElementById('email').value;
    const phoneNumber = document.getElementById('phone_number').value;
    const subject = document.getElementById('msg_subject').value;
    const message = document.getElementById('message').value;
    const toEmail = 'ares@ares.com.ar';

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${toEmail}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(`Nombre: ${name}\nEmail: ${email}\nTeléfono: ${phoneNumber}\n\n${message}`)}`;

    window.open(gmailUrl, '_blank');
};

const Contacto = () => {
    const [isLoading, setLoading] = useState(true);

    const loadScreen = (e) => {
        setLoading(false)
    }

    return (
        <DocumentMeta
            {
            ...{
                title: 'Contacto',
                description: 'Si tiene una consulta, utilice en el formulario que se encuentra debajo. El área correspondiente se estará contactando con usted a la brevedad.',
                canonical: 'https://' + window.location.host + '/contacto',
                meta: {
                    charset: 'utf-8',
                    name: {
                        keywords: 'contacto, consultas, formulario, contacto, ares, ares electronica, ares electronica industrial, ares electronica industrial sa'
                    }
                }
            }
            }
        >
            <div className="page-title-area ptb-100">
                <div className="container">
                    <div className="page-title-content">
                        <h1>Contacto</h1>
                        <p className="text-white">Si tiene una consulta, utilice el formulario que se encuentra debajo. El área correspondiente se estará contactando con usted a la brevedad.</p>
                    </div>
                </div>
                <div className="bg-image">
                    <img src={process.env.PUBLIC_URL + "/assets/img/banner/title.jpg"} alt="" />
                </div>
            </div>
            <section id="contact" className="contact-section contact-single pt-100">
                <div className="container">
                    <div className="top-content">
                        <ul className="info-list">
                            <li><i className="bx bxl-whatsapp" />Whatsapp</li>
                            <li><a href="https://api.whatsapp.com/send/?phone=5491166076608&text&type=phone_number&app_absent=0">+54 (11) 6607 6608</a></li>
                        </ul>
                        <ul className="info-list">
                            <li><i className="bx bx-phone" />Llámenos</li>
                            <li><a href="tel:+54 011-47606060">Tel: +54 (11) 4760 6060</a></li>
                        </ul>
                        <ul className="info-list">
                            <li><i className="bx bx-envelope" />Escríbanos</li>
                            <li><a href="mailto:ares@ares.com.ar">ares@ares.com.ar</a></li>
                        </ul>
                    </div>
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="contact-image mb-30">
                                <iframe id="maps" onLoad={loadScreen} style={{ width: '100%', height: '400px', border: 'none' }} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d580.9484049349547!2d-58.50622586828029!3d-34.54493441344779!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb6d839cdb513%3A0x13426d56a9c0734c!2sAres%20Electr%C3%B3nica%20Industrial%20S.A.!5e0!3m2!1ses-419!2sar!4v1632492944530!5m2!1ses-419!2sar" loading="lazy"></iframe>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-5">
                            <form id="contactfm">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input type="text" name="name" className="form-control" id="name" required data-error="Enter your name" placeholder="Nombre completo" />
                                            <div className="help-block with-errors" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input type="email" name="email" className="form-control" id="email" required data-error="Enter your email" placeholder="Email" />
                                            <div className="help-block with-errors" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input type="text" name="phone_number" className="form-control" id="phone_number" required data-error="Enter your number" placeholder="Teléfono" />
                                            <div className="help-block with-errors" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input type="text" name="msg_subject" className="form-control" id="msg_subject" required data-error="Enter your subject" placeholder="Asunto" />
                                            <div className="help-block with-errors" />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <textarea name="message" id="message" className="form-control" cols={30} rows={8} required data-error="Please enter your message" placeholder="Deje su mensaje..." defaultValue={""} />
                                            <div className="help-block with-errors" />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <button type="submit" className="primary-btn" onClick={openGmail}>Enviar</button>
                                        <div id="contact-message" />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </DocumentMeta>
    );
}



export default Contacto;